import { Module } from 'vuex'
import { mutations } from './mutations'
import getters from './getters'
import { actions } from './actions'
import { RootState } from '~/store'
import { BrandsState } from '~/store/brands/types'

const state = (): BrandsState => ({
  brandsTree: [],
  highlightedBrandsTree: [],
  selectedBrand: null,
})

export const namespaced: boolean = true

const brands: Module<BrandsState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
export default brands
